var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
        _vm.needClass === false? '': 'cp label',
        _vm.themes? 'is-'+ _vm.themes: '',
        _vm.icon? 'icon-font '+ _vm.icon: '',
        _vm.text === '' && _vm.icon? 'icon-font-only': '',
        _vm.extendClass? _vm.extendClass: '' ]},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }